import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api';

function clp(n) {
  return `$${Number(n || 0).toLocaleString('es-CL')}`;
}

export default function InformesCierrePage() {
  const { cid } = useParams();
  const now = new Date();
  const [periodo, setPeriodo] = useState(`${now.getFullYear()}-${now.getMonth() + 1}`);
  const [periodos, setPeriodos] = useState([]);
  const [informe, setInforme] = useState(null);
  const [lotePreview, setLotePreview] = useState(null);
  const [error, setError] = useState('');
  const [msg, setMsg] = useState('');

  useEffect(() => {
    if (!cid) return;
    localStorage.setItem('gc_condominio_id', cid);
    api.get(`/gastos-comunes/condominios/${cid}/periodos`).then((r) => setPeriodos(r.data));
  }, [cid]);

  const cargarVista = () => {
    setError('');
    api
      .get(`/gastos-comunes/condominios/${cid}/reportes/mensual`, { params: { periodo, detalle: 1 } })
      .then((r) => setInforme(r.data))
      .catch((e) => setError(e.response?.data?.error || e.message));
  };

  useEffect(() => {
    if (cid && periodo) cargarVista();
  }, [cid, periodo]);

  const publicar = async () => {
    if (!window.confirm('¿Publicar snapshot del informe comunitario (incluye morosos)?')) return;
    try {
      await api.post(`/gastos-comunes/condominios/${cid}/reportes/mensual/publicar`, { periodo });
      setMsg('Informe publicado. Visible en portal para propietarios.');
      cargarVista();
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const simularAvisos = async () => {
    const parts = periodo.split('-').map(Number);
    const sel = periodos.find((x) => x.anio === parts[0] && x.mes === parts[1]);
    const periodoId = sel?.id;
    if (!periodoId) {
      setError('Cree el período en la lista de períodos primero.');
      return;
    }
    setError('');
    try {
      const { data } = await api.post(`/gastos-comunes/condominios/${cid}/emails/preparar-lote`, { periodoId });
      setLotePreview(data);
      setMsg(`Simulación: ${data.enviables} avisos, ${data.omitidos} omitidos.`);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const confirmarAvisos = async () => {
    if (!lotePreview?.lote?.id) return;
    if (!window.confirm('¿Encolar avisos individuales de cobro?')) return;
    try {
      const { data } = await api.post(
        `/gastos-comunes/condominios/${cid}/emails/lotes/${lotePreview.lote.id}/confirmar`
      );
      setMsg(`Encolados ${data.encolados} correos.`);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
  };

  const periodoSel = periodos.find((p) => `${p.anio}-${p.mes}` === periodo);

  return (
    <>
      <div className="page-header">
        <h2>Informes y cierre mensual</h2>
        <p>Revisión del mes, informe comunitario (con morosos), publicación y avisos de cobro por unidad.</p>
      </div>
      {error && <div className="alert alert-error">{error}</div>}
      {msg && <div className="alert alert-success">{msg}</div>}

      <div className="card">
        <div className="form-row">
          <div className="field">
            <label>Período (AAAA-M)</label>
            <input value={periodo} onChange={(e) => setPeriodo(e.target.value)} />
          </div>
          <div className="field">
            <label>Estado período</label>
            <input readOnly value={periodoSel?.estado || informe?.periodo?.estado || '—'} />
          </div>
        </div>
        <div className="form-row">
          <button type="button" className="btn secondary" onClick={cargarVista}>
            Actualizar vista previa
          </button>
          <button type="button" className="btn" onClick={publicar}>
            Publicar informe
          </button>
          <button
            type="button"
            className="btn secondary"
            onClick={async () => {
              const { data } = await api.get(`/gastos-comunes/condominios/${cid}/reportes/mensual/pdf`, {
                params: { periodo },
                responseType: 'blob'
              });
              window.open(URL.createObjectURL(data), '_blank');
            }}
          >
            PDF vista previa
          </button>
          <button
            type="button"
            className="btn secondary"
            onClick={async () => {
              const { data } = await api.get(`/gastos-comunes/condominios/${cid}/reportes/mensual/csv`, {
                params: { periodo },
                responseType: 'blob'
              });
              const a = document.createElement('a');
              a.href = URL.createObjectURL(data);
              a.download = `informe-${periodo}.csv`;
              a.click();
            }}
          >
            CSV
          </button>
        </div>
      </div>

      {informe && (
        <>
          <div className="stat-grid">
            <div className="stat-card">
              <span className="stat-label">Ingresos caja</span>
              <strong>{clp(informe.resumen?.ingresosCaja)}</strong>
            </div>
            <div className="stat-card">
              <span className="stat-label">Egresos</span>
              <strong>{clp(informe.resumen?.egresosPagados)}</strong>
            </div>
            <div className="stat-card">
              <span className="stat-label">Morosos</span>
              <strong>{informe.resumen?.unidadesConDeuda}</strong>
            </div>
          </div>

          <div className="card">
            <h3 className="card-title">Morosos (informe comunitario)</h3>
            <div className="table-wrap">
              <table className="data-table appsheet-table">
                <thead>
                  <tr>
                    <th>Depto</th>
                    <th>Propietario</th>
                    <th>Deuda total</th>
                  </tr>
                </thead>
                <tbody>
                  {(informe.morosos || []).map((m) => (
                    <tr key={m.unidadId}>
                      <td>{m.codigoDepto}</td>
                      <td>{m.nombre}</td>
                      <td>{clp(m.monto)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="card">
            <h3 className="card-title">Avisos de cobro (simular → confirmar)</h3>
            <div className="form-row">
              <button type="button" className="btn secondary" onClick={simularAvisos}>
                Simular lote
              </button>
              <button type="button" className="btn" onClick={confirmarAvisos} disabled={!lotePreview?.lote?.id}>
                Confirmar envío
              </button>
            </div>
            {lotePreview?.preview?.length > 0 && (
              <div className="table-wrap" style={{ marginTop: 12 }}>
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Depto</th>
                      <th>Email</th>
                      <th>Total</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {lotePreview.preview.slice(0, 30).map((p, i) => (
                      <tr key={i}>
                        <td>{p.codigoDepto}</td>
                        <td>{p.email || '—'}</td>
                        <td>{clp(p.totalPagar)}</td>
                        <td>{p.omitido ? p.motivo : 'Enviar'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
}
